import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SharedModule } from '@shared/shared-module';

@Component({
  selector: 'app-errors',
  imports: [SharedModule],
  templateUrl: './error.html',
})
export class Error implements OnInit {

  code!: string;
  currentYear: number = new Date().getFullYear();

  constructor(
    private route: ActivatedRoute,
  ) {
  }

  ngOnInit() {
    this.code = this.route.snapshot.paramMap.get('code')!;
  }

}
